import $ from 'jquery';
import templateContent from '../util/template_content';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('click', '.dropdown-button__task-template--delete', (e) => {
    e.preventDefault();
    const modal = templateContent(document.getElementById('task-template-delete-confirmation'));
    modal.querySelector('form').action = e.currentTarget.dataset.deleteUrl;
    document.body.append(modal);
  });

  $(document).on('click', '.p-button--save-task-template', (e) => {
    e.preventDefault();
    $('.edit_task_template').submit();
  });
});
